export const CREATE_BAG_SIZE = {
    REQUEST: 'BAG_SIZE.CREATE.REQUEST',
    SUCCESS: 'BAG_SIZE.CREATE.SUCCESS',
    FAILED: 'BAG_SIZE.CREATE.FAILED',
};
